
export function clickedNodeAction(node) {
    return dispatch => {
        dispatch({
            type:'GET_NODE_INFO',
            payload:node
        });
    }
}
